// extracted by mini-css-extract-plugin
export default {"info_container":"Styles_info_container__AIh84","loader_wrapper":"Styles_loader_wrapper__yQAiK"};